/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Delete_FailedInputs */

const en_delete_account_delete_failed = /** @type {(inputs: Delete_Account_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not delete your account at this time. Please try again later or contact your childcare provider or school.`)
};

const es_delete_account_delete_failed = /** @type {(inputs: Delete_Account_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos eliminar tu cuenta en este momento. Inténtalo de nuevo más tarde o comunícate con tu proveedor de cuidado infantil o escuela.`)
};

const ar_delete_account_delete_failed = /** @type {(inputs: Delete_Account_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر حذف حسابك في الوقت الحالي. يرجى المحاولة لاحقا أو الاتصال بمقدم رعاية الأطفال أو المدرسة.`)
};

/**
* | output |
* | --- |
* | "We could not delete your account at this time. Please try again later or contact your childcare provider or school." |
*
* @param {Delete_Account_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_delete_failed = /** @type {((inputs?: Delete_Account_Delete_FailedInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Delete_FailedInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_delete_failed(inputs)
	if (locale === "es") return es_delete_account_delete_failed(inputs)
	return ar_delete_account_delete_failed(inputs)
});